import { api_base } from '../api';
import { logoutUser } from '../actions';
import { toast } from '../../scripts/toast';

export const ShoppingCart = {
	// ----- GET (CURRENT USER) -----
	/* get shopping cart of an user, when this is logged.
	@param id: user id. */
	get(data, cb) {
		if (!data.token) {
			// console.debug('Cannot get the shopping cart, first log in');
		}

		$.ajax({
			url: api_base + '/users/me/shoppingCart/summary',
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + data.token
			},

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ----- ADD -----

	addProduct(user, product, quantity, variation, cb) {
		let data = {
			product_ids: [product.id],
			quantities: [quantity]
		};

		if (variation != 'M') {
			data.variations = [variation];
		}

		$.ajax({
			url: api_base + '/users/me/shoppingCart/put',
			method: 'POST',
			data: data,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Carrito de Compras',
					content: 'El producto ' + product.name + ' fue agregado.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err);
			}
		});
	},

	addProducts (user, shopping_cart, cb) {
		$.ajax({
			url: api_base + '/users/me/shoppingCart/put',
			method: 'POST',
			data: shopping_cart,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Carrito de Compras',
					content: 'Los productos se han agregado.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ----- REMOVE -----

	removeProduct(data, product, cb) {
		$.ajax({
			url: api_base + '/users/me/shoppingCart/remove',
			method: 'POST',
			data: {
				delete_ids: [product.product_id],
				variations: [product.variation]
			},
			headers: {
				Authorization: 'Bearer ' + data.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Carrito de Compras',
					content: 'El producto ' + product.product.name + ' fue removido.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err);
			}
		});
	},

	checkout(data, params, form, cb) {
		let url = [
      api_base,
      '/users/me/shoppingCart/checkout?',
      'willBeDelivered=1',
      '&shippmentType=shippment_company',
      `&shippingAddress=${params.shipping_address}`,
      `&method=${params.method}`
    ].join('');
		// if (!params.will_be_delivered) {
		// 	url = api_base + '/users/me/shoppingCart/checkout?' +
		// 		'willBeDelivered=0' +
		// 		'&method=' + params.method;
		// } else {
		// 	url = api_base + '/users/me/shoppingCart/checkout?' +
		// 		'willBeDelivered=1' +
		// 		'&shippmentType=' + params.shippment_type +
		// 		'&shippingAddress=' + params.shipping_address +
		// 		'&method=' + params.method;
		// }
		// if has promo code set to the params.
		if (params.promo_code) {
			url += '&promo_code=' + params.promo_code.promo_code;
		}

		$.ajax({
			url: url,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + data.token,
				Accept: 'application/json'
			},

			success: function (res) {
				form.is_submited = false;

				if (params.method === 'paypalplus') {
					return cb(res);
				}

				// if (params.method == 'bancomer') {
				// 	return cb(res);
				// }

				window.location = res.redirect;
			},

			error: function (err) {
				form.is_submited = false;

				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err);
			}
		})
	},

	update (user, products, cb) {
		let data = {}
		data.product_ids = []
		data.quantities = []
		data.variations = []

		for (let i = 0; i < products.length; i++) {
			data.product_ids.push(products[i].product_id)
			data.quantities.push(products[i].quantity)
			data.variations.push(products[i].variation)
		}

		$.ajax({
			url: api_base + '/users/me/shoppingCart/update',
			method: 'POST',
			data: data,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res)
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				if (err.status == 401) {
					logoutUser(Store, '/home');
					toast({
						title: 'Sesión Expirada',
						content: 'Inicia sesión de nuevo.'
					});
				}

				// console.log(err)
			}
		})
	}
};



// WEBPACK FOOTER //
// ./src/store/api/shopping_cart.js